// extracted by mini-css-extract-plugin
export default {"container":"F23wDC","thumbnail":"qLTdLE","thumbnailLink":"BrjTn_","hoverPanel":"GdrKLR","navigation":"sIFxzI","img":"tsmtrk","title":"_rZTz7","secondary":"ixcN5D"};